import React, { useState, useMemo, useEffect } from "react";
import { useDispatch } from "react-redux";
import { classSessionAction } from "redux/actions";
import { TabModal } from "components";
import CategoryDetails from "./CategoryDetails";
import LocationDetails from "./LocationDetails";
import RoutingDetails from "./RoutingDetails";

export default function RoutingPopup({ closeModal, data }) {
  // redux
  const dispatch = useDispatch();

  // states
  const [tabIndex, setTabIndex] = useState(0);
  const [details, setDetails] = useState();

  // useEffects
  useEffect(() => {
    if (!data) return;

    const {
      id,
      category,
      sub_category_id,
      package_id,
      from_date,
      to_date,
      class_time
    } = data;

    setDetails({
      id: id,
      category: category,
      sub_category_id: sub_category_id,
      package_id: package_id,
      from_date: from_date,
      to_date: to_date,
      class_time: class_time
    });
  }, [data]);

  useEffect(() => {
    console.log({ details });
  }, [details]);

  // Handle change in Form
  const handleChange = e => {
    setDetails(prev => ({
      ...prev,
      [e.target.name]: isNaN(e.target.value)
        ? e.target.value
        : parseFloat(e.target.value)
    }));
  };

  // On Submit Data to Server
  const submit = () => {
    console.log('===========>>>>>>>'+JSON.stringify(details));
    // if (!details?.subCategoryID || !details?.cityID || !details?.ruleID) {
    //   alert("City, Sub Category & Rule ID is mandatory.");
    //   return;
    // }

    setTabIndex(0);
    closeModal();
    dispatch(classSessionAction.generate(details));
  };

  // Popup tabs routes
  const modalTabs = useMemo(
    () => [
      {
        name: "Category Details",
        component: (
          <CategoryDetails
            key={1}
            onClick={e => setTabIndex(1)}
            details={details}
            setDetails={handleChange}
          />
        )
      },
      {
        name: "Session Details",
        component: (
          <RoutingDetails
            key={3}
            onClick={submit}
            details={details}
            setDetails={handleChange}
          />
        )
      }
    ],
    [details]
  );

  return (
    <TabModal
      tabTitle={data ? "Edit Routing" : "Generate Class Sessions"}
      tabs={modalTabs}
      tabIndex={tabIndex}
      setTabIndex={index => setTabIndex(index)}
      closeModal={() => {
        setTabIndex(0);
        closeModal();
      }}
    />
  );
}
